import { Image } from '@storyofams/storyblok-toolkit';
import { classNames, getLinkProps } from '~/lib';
import { Heading } from '../Heading';
import { ArrowRight } from '../Icons';
import { Link } from '../Link';

export const ArticleCard = ({ article }: { article?: any }) => {
  const title =
    article?.component === 'internal_article'
      ? article?.article?.story?.name
      : article?.title;
  const image =
    article?.component === 'internal_article'
      ? article?.article?.story?.content?.thumbnail
      : article?.image;

  const link =
    article?.component === 'internal_article'
      ? article?.article
      : article?.link;

  const kicker =
    article?.component === 'internal_article' ? 'Blog' : article?.kicker;

  const type =
    article?.component === 'internal_article'
      ? article?.article?.story?.content?.type
      : article?.label;

  return (
    <Link
      href={getLinkProps(link)}
      className={classNames(
        'flex flex-col md:flex-row w-full group h-full mb-8 last:mb-0',
      )}
      key={article?._uid}
    >
      <div
        className={classNames(
          'flex-shrink-0 rounded-2xl overflow-hidden image--rounded  w-full md:max-w-xs',
        )}
      >
        <div className="w-full h-[200px] relative">
          {!!type && (
            <p className="px-2.5 py-1 bg-gray-50 border border-gray-100 rounded-full absolute left-5 top-5 z-10 text-grey-700 text-sm">
              {type}
            </p>
          )}

          <Image
            alt={image?.alt || ''}
            src={image?.filename}
            fluid={800}
            fit="cover"
            showPlaceholder={false}
            height="100%"
            className="w-full"
          />
        </div>
      </div>
      <div className="md:ml-8 mt-4 mb-6 flex flex-col justify-between">
        <div>
          <Heading variant="h6" as="h6" className="capitalize text-yellow-600">
            {kicker}
          </Heading>
          <Heading variant="h5" as="h2" className="!text-xl mt-3">
            {title}
          </Heading>
        </div>
        <p className="inline-flex items-center text-gray-800 mt-8 md:mt-0">
          Read more
          <ArrowRight
            className="w-4 h-4 ml-2 -mb-0.25 transition-transform group-hover:translate-x-0.5"
            aria-hidden="true"
          />
        </p>
      </div>
    </Link>
  );
};
